export default "__VITE_ASSET__rvFGOf4M__"